import { DSComplexScore } from 'shared-definitions/types'
import { ApiReviewProductScore } from 'data-source/types.wp'

export function reviewProductScoreMapper(input: ApiReviewProductScore): DSComplexScore {
  return {
    label: input.name,
    ourScore: input.admin_rating,
    userScore: {
      postId: input.post_id,
      key: input.key,
      val: input.average_value === 0 ? null : input.average_value,
    },
  }
}
